import { render, staticRenderFns } from "./TagDerMusikschulen.vue?vue&type=template&id=de292938&"
import script from "./TagDerMusikschulen.vue?vue&type=script&lang=js&"
export * from "./TagDerMusikschulen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports